<script lang="ts">
  import { defineComponent } from 'vue';
  import { OrderRescheduledNotificationType } from '@/helpers/types';
  import { RouteNames } from '@/helpers/enums';
  import DataSeparator from '@/components/ui/DataSeparator.vue';

  export default defineComponent({
    components: { DataSeparator },
    props: {
      data: {
        type: Object as () => OrderRescheduledNotificationType,
        required: true,
      },
    },
    emits: {
      close: () => true,
    },
    methods: {
      onNotificationClicked(): void {
        this.$emit('close');
        this.$router.push({
          name: RouteNames.orderDetails,
          params: {
            facilityOrderId: this.data.id,
          },
        });
      },
    },
  });
</script>

<template>
  <div @click="onNotificationClicked">
    <div class="d-flex flex-row align-items-center gap-8 mb-8">
      <h5 class="text-gray fw-semibold">{{ data.orderNumber }}</h5>
      <DataSeparator />
      <h5 class="text-gray fw-semibold">{{ data.customerName }}</h5>
    </div>
    <h4 class="fw-semibold">{{ data.body }}</h4>
    <hr class="dashed mt-16 mb-24" />
    <div class="d-flex flex-grow-1 justify-content-center">
      <p class="link fw-bold">{{ $t('actions.view_order') }}</p>
    </div>
  </div>
</template>
